/*!
 * isobject <https://github.com/jonschlinkert/isobject>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */

'use strict';

module.exports = function isObject(val) {
  return val != null && typeof val === 'object' && Array.isArray(val) === false;
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/isobject/index.js
 ** module id = 1047
 ** module chunks = 0
 **/